<template>
    <div class="content"  v-show="param.showFilter">
      <!-- 资讯筛选 -->
      <van-row class="label-content" v-if="param && param.filterType === 'news'">
        <van-col :span="23" :offset="1">
          <div class="label" :class="{'label-selected': newsSelectedIndex == 0}" @click="newsSelectedLabel(0)">全部</div>
        </van-col>
        <van-col :span="23" :offset="1">
          <!-- 接口数据渲染 -->
          <div class="label" :class="{'label-selected': newsSelectedIndex == 1}" @click="newsSelectedLabel(1)">黑科技</div>
          <div class="label" :class="{'label-selected': newsSelectedIndex == 2}" @click="newsSelectedLabel(2)">行业资讯</div>
          <div class="label" :class="{'label-selected': newsSelectedIndex == 3}" @click="newsSelectedLabel(3)">方案解析</div>
          <div class="label" :class="{'label-selected': newsSelectedIndex == 4}" @click="newsSelectedLabel(4)">优秀设计师</div>
          <div class="label" :class="{'label-selected': newsSelectedIndex == 5}" @click="newsSelectedLabel(5)">每日三分钟</div>
          <div class="label" :class="{'label-selected': newsSelectedIndex == 6}" @click="newsSelectedLabel(6)">行业干货</div>
        </van-col>
      </van-row>
      <!-- 方案筛选 -->
      <van-row class="sol-filter-content" v-if="param && param.filterType === 'sol'">
        <van-col :span="5" class="sol-filter-left">
          <!-- <div :class="{selected: solFilterPP.selected}" @click="toggle(0)">品牌</div> -->
          <div :class="{selected: solFilterYT.selected}" @click="toggle(1)">建筑业态</div>
          <div :class="{selected: solFilterSX.selected}" @click="toggle(2)">系统属性</div>
        </van-col>
        <van-col :span="19" class="sol-filter-right">
          <!-- 品牌 -->
          <div v-show="solFilterPP.selected" class="brands-content">
            <van-row>
              <van-col :span="24" class="sol-filter-right-all">
                <div :class="{selected: solFilterPP && solFilterPP.right === 0}" @click="PPChange({brandId: 0, brandName: ''})">全部</div>
              </van-col>
            </van-row>
            <van-row v-for="item of brandsData" :key="item.letter">
              <van-col :span="24" class="sol-filter-right-num" v-if="item.list && item.list.length > 0">{{item.letter}}</van-col>
              <van-col :span="24" class="sol-filter-right-label"  v-if="item.list && item.list.length > 0">
                <div v-for="brand of item.list" :key="brand.brandId" :class="{selected: solFilterPP && solFilterPP.right === brand.brandId}" @click="PPChange(brand)">{{brand.brandName}}</div>
              </van-col>
            </van-row>
          </div>
          <!-- 建筑业态 -->
          <div v-if="solFilterYT.selected">
            <van-row>
              <van-col :span="24" class="sol-filter-right-all">
                <div :class="{selected: solFilterYT && solFilterYT.right === 0}"  @click="YTChange({id: 0, name: ''})">全部</div>
              </van-col>
              <van-col :span="24" class="sol-filter-right-label">
                <div v-for="item of build" :key="item.id" :class="{selected: solFilterYT && solFilterYT.right === item.id}"  @click="YTChange(item)">{{item.name}}</div>
              </van-col>
            </van-row>
          </div>
          <!-- 系统属性 -->
          <div v-if="solFilterSX.selected">
            <van-row>
              <van-col :span="24" class="sol-filter-right-all">
                <div :class="{selected: solFilterSX && solFilterSX.right === 0}"  @click="SXChange({id: 0, name: ''})">全部</div>
              </van-col>
              <van-col :span="24" class="sol-filter-right-label">
                <div v-for="item of property" :key="item.id" :class="{selected: solFilterSX && solFilterSX.right === item.id}"  @click="SXChange(item)">{{item.name}}</div>
              </van-col>
            </van-row>
          </div>
        </van-col>
      </van-row>
      <!-- 抛出返回结果/关闭当前页 -->
      <van-row class="footer">
        <van-col :span="12"><button @click="close" class="filter-close">返回</button></van-col>
        <van-col :span="12" class="confirm"><button @click="confirm">确认</button></van-col>
      </van-row>
    </div>
</template>

<script>
import { Row, Col } from 'vant'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'sol-or-news-filter',
  components: { Row, Col },
  props: ['param'],
  computed: {
    ...mapState({
      brands: state => state.baseData.brands, // 品牌
      property: state => state.baseData.property, // 系统属性
      build: state => state.baseData.build // 建筑业态
    }),
    ...mapGetters({
      brandsData: 'BASE_DATA_FILTER_BRANDS_DATA'
    })
  },
  data () {
    return {
      newsSelectedIndex: 0,
      solSelectedIndex: 0,
      filterRightHeight: 0,
      /* 品牌 */
      solFilterPP: {
        selected: false,
        left: 0,
        right: 0,
        name: ''
      },
      /* 业态 */
      solFilterYT: {
        selected: true,
        left: 0,
        right: 0,
        name: ''
      },
      /* 系统属性 */
      solFilterSX: {
        selected: false,
        left: 0,
        right: 0,
        name: ''
      },
      tagMap: {
        '黑科技': 1,
        '行业资讯': 2,
        '方案解析': 3,
        '优秀设计师': 4,
        '每日三分钟': 5,
        '行业干货': 6
      },
      selectedFilter: {
        type: '',
        filter: {
          right: 0,
          name: ''
        }
      }
    }
  },
  created () {
    this.newsSelectedIndex = this.tagMap[this.$route.query.tagName] | 0
    this.filterRightHeight = window.innerHeight - 45
    // 品牌数据 不存在则查询接口
    if (!this.brands || this.brands.length === 0) {
      this.$store.dispatch('BASE_DATA_GET_BRANDS')
    }
    // 系统属性数据 不存在则查询接口
    if (!this.property || this.property.length === 0) {
      this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 5)
    }
    // 建筑业态数据 不存在则查询接口
    if (!this.build || this.build.length === 0) {
      this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 6)
    }
  },
  methods: {
    /* 资讯选择筛选条件 */
    newsSelectedLabel (index) {
      this.newsSelectedIndex = index
    },
    solSelectedLabel (index) {
      this.newsSelectedIndex = index
    },
    /* 关闭当前页 */
    close () {
      this.param.showFilter = false
      /* if (this.param.filterType === 'sol') {
        // 还原选择
        this.solFilterPP.selected = false
        this.solFilterPP.right = 0
        this.solFilterPP.name = ''
        this.solFilterYT.selected = false
        this.solFilterYT.right = 0
        this.solFilterYT.name = ''
        this.solFilterSX.selected = false
        this.solFilterSX.right = 0
        this.solFilterSX.name = ''
        if (this.selectedFilter.type === '') {
          this.solFilterPP.selected = true
        } else {
          this[this.selectedFilter.type].selected = true
          this[this.selectedFilter.type].right = this.selectedFilter.right
          this[this.selectedFilter.type].name = this.selectedFilter.name
        }
      } */
    },
    /* 抛出查询条件并关闭当前页 */
    confirm () {
      this.param.showFilter = false
      /* 资讯 */
      if (this.param.filterType === 'news') {
        this.$emit(this.param.callBack, `${this.newsSelectedIndex}`)
      }
      /* 方案 */
      if (this.param.filterType === 'sol') {
        this.$emit(this.param.callBack, [{ type: 'PP', id: this.solFilterPP.right, name: this.solFilterPP.name }, { type: 'YT', id: this.solFilterYT.right, name: this.solFilterYT.name }, { type: 'SX', id: this.solFilterSX.right, name: this.solFilterSX.name }])
      }
    },
    toggle (val) {
      this.solFilterPP.selected = false
      this.solFilterYT.selected = false
      this.solFilterSX.selected = false
      if (val === 0) {
        this.solFilterPP.selected = true
      }
      if (val === 1) {
        this.solFilterYT.selected = true
      }
      if (val === 2) {
        this.solFilterSX.selected = true
      }
    },
    PPChange (item) {
      this.solFilterPP.right = item.brandId
      this.solFilterPP.name = item.brandName
    },
    YTChange (item) {
      this.solFilterYT.right = item.id
      this.solFilterYT.name = item.name
    },
    SXChange (item) {
      this.solFilterSX.right = item.id
      this.solFilterSX.name = item.name
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  z-index: 9;
}
.label-content{
  padding-top: 10px;
  background-color: #ffffff;
}
.label{
  margin-bottom: 10px;
  margin-right: 10px;
  color: #999999;
  height: 30px;
  line-height: 30px;
  border: 1px solid #999999;
  border-radius: 4px;
  box-sizing: border-box;
  display: inline-block;
  padding: 0 20px;
  font-size: 12px;
  &:first-child {
    padding: 0 25px;
  }
  &-selected{
    color: #1DBFDA;
    border-color: #1DBFDA;
  }
}
.footer{
  position: fixed;
  bottom: 0px;
  height: 45px;
  line-height: 45px;
  border-top: 1px solid #D8D8D8;
  box-sizing: border-box;
  z-index: 9;
  width: 100%;
  background-color: #fafafa;
  text-align: center;
  .confirm{
    position: relative;
    &::before{
       content: '';
       border-left: 1px solid #D8D8D8;
       height: 44px;
       position: absolute;
       left: 0;
     }
     button{
       width: 100%;
       height: 100%;
       font-size: 14px;
       color: white;
       border: 0;
       background-color: #1DBFDA;
     }
  }
  .filter-close{
    width: 100%;
    height: 100%;
    background-color: white;
    border: 0;
  }
}
.sol-filter-content{
  height: 100%;
}
.sol-filter-left{
  background-color: #ffffff;
  div{
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #D8D8D8;
    text-align: center;
    &:last-child{
       border: none;
     }
    &.selected{
       color: #1DBFDA;
       position: relative;
       &::before{
          content: '';
          width: 2px;
          height: 50px;
          position: absolute;
          left: 0;
          top: 0;
          background-color: #1DBFDA;
       }
    }
  }
}
.sol-filter-right{
  background-color: #ffffff;
  border-left: 1px solid #D8D8D8;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  .brands-content{
    margin-bottom: 50px;
  }
  &-all{
    div {
      display: inline-block;
      height: 30px;
      line-height: 30px;
      padding-left: 15px;
      padding-right: 15px;
      border: 1px solid #D8D8D8;
      border-radius: 4px;
      margin-left: 10px;
      margin-top: 10px;
      box-sizing: border-box;
      &.selected {
        color: #1DBFDA;
        border-color: #1DBFDA;
      }
    }
   }
  &-num{
    margin-top: 10px;
    font-size: 12px;
    height: 16px;
    line-height: 16px;
    margin-left: 10px;
   }
  &-label{
    div{
      display: inline-block;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      padding-right: 10px;
      border: 1px solid #D8D8D8;
      border-radius: 4px;
      margin-left: 10px;
      margin-top: 10px;
      box-sizing: border-box;
      &.selected{
         color: #1DBFDA;
         border-color: #1DBFDA;
       }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/filter.vue